var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "docTemplateEdit-container"
  }, [_c('a-card', [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.mode === 'edit' ? '编辑模板' : '查看模板'))]), _c('a-space', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a-button', {
    on: {
      "click": _vm.backPage
    }
  }, [_vm._v("返回")]), _vm.mode == 'edit' ? _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateTempScopeClick
    }
  }, [_vm._v(" 保存 ")]) : _vm._e()], 1)], 1)]), _c('a-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_c('a-card', {
    staticClass: "body-content",
    attrs: {
      "size": "small"
    }
  }, [_vm.form.id == 1 ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("绵阳中学英才学校纪委办拟文稿")]), _c('a-row', {
    staticStyle: {
      "margin-top": "0.625rem"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-left"
  }, [_c('div', [_vm._v(" 文件编号： "), _c('span', {
    staticClass: "content-font"
  })])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 缓急： "), _c('span', {
    staticClass: "content-font"
  })])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 密级： "), _c('span', {
    staticClass: "content-font"
  })])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left double-height"
  }, [_c('div', [_vm._v("文件名称：")]), _c('div', {
    staticClass: "content-font"
  })])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right double-height"
  }, [_c('div', [_vm._v("附件：")]), _c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left triple-height-x2"
  }, [_c('div', [_vm._v("签发：")]), _c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "sign-content"
  }, [_c('span', [_vm._v("纪委书记（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "5.625rem"
    }
  }, [_vm._v("日期：")])])])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right triple-second-height-x2"
  }, [_c('div', [_vm._v("初核：")]), _c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "sign-content"
  }, [_c('span', [_vm._v("纪委办主任（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "3.625rem"
    }
  }, [_vm._v("日期：")])])])]), _c('div', {
    staticClass: "form-content-content-right triple-second-height"
  }, [_c('div', [_vm._v("拟稿：")]), _c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "margin-top:1.5rem"
  }, [_c('span', [_vm._v("拟稿人（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "0.825rem"
    }
  }, [_vm._v("日期：")])])])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("主送")]), _c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("抄送")]), _c('div', {
    staticClass: "content-font"
  })])])], 1)], 1) : _vm._e(), _vm.form.id == 2 ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("中共绵阳中学英才学校委员会拟文稿")]), _c('a-row', {
    staticStyle: {
      "margin-top": "0.625rem"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-left"
  }, [_c('div', [_vm._v(" 文件编号： "), _c('span', {
    staticClass: "content-font"
  })])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 缓急： "), _c('span', {
    staticClass: "content-font"
  })])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-top-right"
  }, [_c('div', [_vm._v(" 密级： "), _c('span', {
    staticClass: "content-font"
  })])])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left double-height"
  }, [_c('div', [_vm._v("文件名称：")]), _c('div', {
    staticClass: "content-font"
  })])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right double-height"
  }, [_c('div', [_vm._v("附件：")]), _c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form-content-content-left triple-height-x2"
  }, [_c('div', [_vm._v("签发：")]), _c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "sign-content"
  }, [_c('span', [_vm._v("党委书记（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "5.625rem"
    }
  }, [_vm._v("日期：")])])])])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "form-content-content-right triple-first-height"
  }, [_c('div', [_vm._v("复核：")]), _c('div', {
    staticClass: "content-font"
  }, [_c('div', {
    staticClass: "sign-content-fuhe"
  }, [_c('span', [_vm._v("专职副书记（签字）:")]), _c('div', {
    staticStyle: {
      "margin-top": "1.625rem"
    }
  }, [_vm._v("日期：")])])])]), _c('div', {
    staticClass: "form-content-content-right triple-second-height"
  }, [_c('div', [_vm._v("初核：")]), _c('div', {
    staticClass: "content-font"
  })]), _c('div', {
    staticClass: "form-content-content-right triple-second-height"
  }, [_c('div', [_vm._v("拟稿：")]), _c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("会签：")]), _c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("主送：")]), _c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "form-content-content-left"
  }, [_c('div', [_vm._v("抄送")]), _c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-left"
  }, [_c('div', [_vm._v("打印：")])])]), _c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  })]), _c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  }, [_c('div', [_vm._v("校对：")])])]), _c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  })]), _c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  }, [_c('div', [_vm._v("份数：")])])]), _c('a-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "form-content-bottom-right"
  })])], 1)], 1) : _vm._e(), _vm.form.id == 3 ? _c('div', [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("绵阳中学英才学校发文审批单")]), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "form2-content-top-left"
  }, [_c('div', [_vm._v(" 理事长签发： "), _c('span', {
    staticClass: "content-font"
  })])])]), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "form2-content-top-right-top"
  }, [_vm._v("拟稿部门")]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_vm._v("审稿部门")]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_vm._v("分管校级领导审核")]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_vm._v("会签")])]), _c('a-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "form2-content-top-right-top"
  }, [_c('span', {
    staticClass: "content-font"
  })]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_c('span', {
    staticClass: "content-font"
  })]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_c('span', {
    staticClass: "content-font"
  })]), _c('div', {
    staticClass: "form2-content-top-right"
  }, [_c('span', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left"
  }, [_c('div', [_vm._v("日期")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right"
  }, [_c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left double-height"
  }, [_c('div', [_vm._v("标题")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right double-height"
  }, [_c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left triple-height"
  }, [_c('div', [_vm._v("抄送")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right triple-height"
  }, [_c('div', {
    staticClass: "content-font"
  })])])], 1)], 1) : _vm._e(), _vm.form.id == 4 ? _c('div', [_c('div', {
    staticClass: "form-title",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v(" 绵阳中学英才学校公文处理笔笺 ")]), _c('a-row', [_c('a-col', {
    staticStyle: {
      "border-top": "1px solid red"
    },
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("公文标题")])])]), _c('a-col', {
    staticStyle: {
      "border-top": "1px solid red"
    },
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("拟办意见")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("党委书记批示")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  })])])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "form2-content-content-left",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', [_vm._v("办理结果")])])]), _c('a-col', {
    attrs: {
      "span": 21
    }
  }, [_c('div', {
    staticClass: "form2-content-content-right",
    staticStyle: {
      "border-color": "red"
    }
  }, [_c('div', {
    staticClass: "content-font"
  })])])], 1)], 1) : _vm._e()])], 1), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('a-card', {
    staticClass: "body-content",
    attrs: {
      "size": "small"
    }
  }, [_c('a-form-model', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "模板可使用范围",
      "prop": "scope"
    }
  }, [_c('div', [_c('select-person', {
    ref: "personPick",
    class: _vm.mode == 'edit' ? '' : 'disabled-content',
    attrs: {
      "tabList": _vm.groupMap,
      "width": "100%",
      "height": "9.375rem"
    },
    model: {
      value: _vm.groupsList,
      callback: function callback($$v) {
        _vm.groupsList = $$v;
      },
      expression: "groupsList"
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };